import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { MenuSection } from "./components/MenuSection";
import { Toppings } from "./components/Toppings";
import { Reviews } from "./components/Reviews";
import { Gallery } from "./components/Gallery";
import { LocationSection } from "./components/LocationSection";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-white text-ink min-h-screen" data-testid="app-root">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <MenuSection />
        <Toppings />
        <Reviews />
        <Gallery />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
